import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import FormField from '../../../forms/FormField';

const required = value => value ? undefined : 'Required';

const checkError = error => {
  const { jsonData } = error || {};
  const { json } = jsonData || {};
  const { message } = json || {};

  if (!message) return;

  switch (message) {
    case 'Payment exists':
      return message;
    case 'Daily card limit has been reached':
      return 'Limit';
    case 'Default Card':
      return 'Default Card';
    default:
      return 'Generic';
  }
};

const EditPaymentForm = (
  {
    handleSubmit,
    submitting,
    selectedAddressValue,
    errorSubmit,
    editType,
    toggle,
    lookups,
    AddressBook,
    initialValues,
    fromClubPaymentModal,
    style
  }
) => {
  const {
    states
  } = lookups || {};

  const { cardId } = initialValues || {};

  if (!cardId && editType === 'Edit') toggle('payment');

  const stateOptions = (states || [])
    .filter(({ countryId }) => countryId === 37)
    .map(({ stateId, stateName }) => ({
      value: stateId,
      label: stateName
    }));

  const addressOptions = (AddressBook || []).map(({
    Address1,
    Address2,
    City,
    StateShort,
    Zip,
    AddressBookID
  }) => ({
    value: AddressBookID,
    label: `${Address1} ${Address2 || ''}, ${City} ${StateShort}, ${Zip}`
  }));

  const formSubmitError = checkError(errorSubmit);

  return (
    <div className="col-products" style={style}>
      {!fromClubPaymentModal &&
        <h1 className="smaller account-header">{editType} Payment</h1>}
      {!fromClubPaymentModal &&
        <h3 className="before-form">
          <a style={{ cursor: 'pointer' }} onClick={() => toggle('payment')}>
            <i className="fas fa-chevron-left" /> Back To Payment
          </a>
        </h3>}
      <form onSubmit={handleSubmit}>
        <h3>Payment</h3>
        <div className="form-row">
          <div className="col-md-6">
            <Field
              name="name_first"
              type="text"
              component={FormField.Input}
              placeholder="First Name"
              validate={[required]}
            />
          </div>
          <div className="col-md-6">
            <Field
              name="name_last"
              type="text"
              component={FormField.Input}
              placeholder="Last Name"
              validate={[required]}
            />
          </div>
        </div>
        <div className="form-row">
          {editType === 'Add' &&
            <div className="col-md-6">
              <Field
                name="cardNumber"
                type="text"
                component={FormField.Input}
                placeholder="Card Number"
                validate={[required]}
              />
            </div>}
          {editType === 'Edit' &&
            <div className="col-md-6">
              <p className="account-info-block">
                Card Type: ****-****-****-{initialValues.LastFour}
              </p>
            </div>}
          <div className="col-md-2 col-4">
            <div className="form-group">
              <span
                className="form-disclaimer alt"
                style={{ transform: 'translateY(-0.5em)' }}
              >
                Expiration Date:
              </span>
            </div>
          </div>
          <div className="col-md-4 col-8">
            <div className="form-row">
              <div className="col">
                <Field
                  name="ExpirationMonth"
                  type="text"
                  component={FormField.SelectReact}
                  placeholder="Exp Month"
                  validate={[required]}
                  options={[
                    { value: 1, label: 'January' },
                    { value: 2, label: 'February' },
                    { value: 3, label: 'March' },
                    { value: 4, label: 'April' },
                    { value: 5, label: 'May' },
                    { value: 6, label: 'June' },
                    { value: 7, label: 'July' },
                    { value: 8, label: 'August' },
                    { value: 9, label: 'September' },
                    { value: 10, label: 'October' },
                    { value: 11, label: 'November' },
                    { value: 12, label: 'December' }
                  ]}
                />
              </div>
              <div className="col">
                <Field
                  name="ExpirationYear"
                  type="text"
                  component={FormField.SelectReact}
                  placeholder="Exp Year"
                  validate={[required]}
                  options={Array.from(Array(11), (_, i) => ({
                    value: new Date().getFullYear() + i,
                    label: new Date().getFullYear() + i
                  }))}
                />
              </div>
            </div>
          </div>
        </div>
        <h3 className="in-form">Billing Address</h3>
        <Field
          name="AddressBookId"
          type="text"
          component={FormField.SelectReact}
          placeholder="Select or add address..."
          validate={[required]}
          options={[{ value: 'add', label: 'Add Address' }, ...addressOptions]}
        />
        {selectedAddressValue === 'add' &&
          <div>
            <div className="form-row">
              <div className="col-md-9">
                <Field
                  name="Address1"
                  type="text"
                  component={FormField.Input}
                  placeholder="Address"
                  validate={[required]}
                />
              </div>
              <div className="col-md-3">
                <Field
                  name="Address2"
                  type="text"
                  component={FormField.Input}
                  placeholder="Apt/Suite"
                />
              </div>
            </div>
            <div className="form-row">
              <div className="col-md-4">
                <Field
                  name="City"
                  type="text"
                  component={FormField.Input}
                  placeholder="City"
                  validate={[required]}
                />
              </div>
              <div className="col-md-4">
                <Field
                  name="StateID"
                  type="text"
                  component={FormField.SelectReact}
                  placeholder="State"
                  validate={[required]}
                  options={stateOptions}
                />
              </div>
              <div className="col-md-4">
                <Field
                  name="Zip"
                  type="text"
                  component={FormField.Input}
                  placeholder="Zip"
                  validate={[required]}
                />
              </div>
            </div>
          </div>}
        {!fromClubPaymentModal &&
          <div className="form-row">
            <div className="col-md-12">
              <div className="form-group">
                <Field
                  required
                  name="IsDefault"
                  type="checkbox"
                  component={FormField.InlineCheckbox}
                  label="Make my default method of payment (including Member Shipments)"
                  normalize={value => !!value}
                />
              </div>
            </div>
          </div>}

        {!fromClubPaymentModal &&
          <div className="form-row">
            <div className="col-md-3 form-group">
              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={submitting}
              >
                Save
              </button>
            </div>
            <div className="col-md-3">
              <button
                type="button"
                className="btn btn-inverse btn-block"
                onClick={() => toggle('payment')}
                disabled={submitting}
              >
                Cancel
              </button>
            </div>
          </div>}

        {formSubmitError === 'Generic' &&
          <div className="form-row">
            <span style={{ color: '#dc3545', marginLeft: '10px' }}>
              An error occurred trying to add this payment.
            </span>
          </div>}
        {formSubmitError === 'Default Card' &&
          <div className="form-row">
            <span style={{ color: '#dc3545', marginLeft: '10px' }}>
            This card is currently set as your default for your membership order. If you wish to use a different card, please add a new one and designate it as your new default card. You can always return to remove this card later.
            </span>
          </div>}
        {formSubmitError === 'Limit' &&
          <div className="form-row">
            <span style={{ color: '#dc3545', marginLeft: '10px' }}>
              Daily card limit has been reached. Please contact Customer Care if you believe this message was received in error
            </span>
          </div>}
      </form>
    </div>
  );
};

const formName = 'edit-payment-form';
const selector = formValueSelector(formName);

const mapState = state => {
  const selectedAddressValue = selector(state, 'AddressBookId') || null;
  return { selectedAddressValue };
};

const form = reduxForm({ form: formName })(EditPaymentForm);

export default connect(mapState)(form);
